import { AfterViewInit, ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Automation, ChoicesInterface, RuleInterface } from '@vendasta/automata';
import { CommonTriggerPanelComponent } from '../../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../../common/decorators/trigger-rules.decorator';
import { ProductActivationPanelComponent } from '../../product-activations/product-activation-panel/product-activation-panel.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  templateUrl: './product-deactivated-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    ProductActivationPanelComponent,
  ],
})
export class ProductDeactivatedPanelComponent extends CommonTriggerPanelComponent implements AfterViewInit {
  @Input() triggerChoices: ChoicesInterface;
  @Input() taskDefinitionId: string;
  @Input() automation: Automation;
  @ViewChild('commonProductPanel') commonPanel: ProductActivationPanelComponent;

  ngAfterViewInit(): void {
    // When the common panel is ready, we're ready.
    // This implementation relies on the common panel closing its observable.
    this.commonPanel.savingEnabled$.subscribe((enabled) => {
      this.savingEnabled$.next(enabled);
    });
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return this.commonPanel.getControlsToValidateOnSave();
  }

  isFormValid(): boolean {
    return this.commonPanel.isFormValid();
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return this.commonPanel.getBaseRules();
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return this.commonPanel.fillRuleValues(rules);
  }
}
